import request from '@/utils/request'

export function getApprovalsList() {
  return request({
    url: '/approval/getmyapprovalslist',
    method: 'get'
  })
}

export function getApprovalsDetail(params) {
  return request({
    url: '/approval/getmyapprovalsdetail',
    method: 'get',
    params
  })
}

export function auditApprovals(data) {
  return request({
    url: '/approval/auditapprovals',
    method: 'post',
    data
  })
}
